import { useState } from "react";
import styled from "styled-components/macro";
import { Grid, Chip as MUIChip } from "@mui/material";

import { TextField } from "../../../../components";

const Chip = styled(MUIChip)`
  border-radius: 30px;
  margin: 2px;
`;

export default function Cc({ formikProps }) {
  const [inputValue, setInputValue] = useState("");

  function handleDelete(index) {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      ...prevVal.cc?.splice(index, 1),
    }));
  }

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function handleKeyDown(event) {
    if (event.key === "Enter" || event.keyCode === 32) {
      const newMails = [...formikProps.values.cc];

      const duplicatedValues = newMails.indexOf(event.target.value.trim());

      if (duplicatedValues !== -1) {
        setInputValue("");
        return;
      }

      if (!event.target.value.replace(/\s/g, "").length) return;

      newMails.push(event.target.value.trim());
      for (let mail of newMails) {
        if (!validateEmail(mail)) {
          return;
        }
      }
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        cc: newMails,
      }));
      setInputValue("");
    }
    if (
      formikProps.values.cc.length &&
      !inputValue.length &&
      event.key === "Backspace"
    ) {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        cc: prevVal.cc?.slice(0, prevVal.cc.length - 1),
      }));
    }
  }

  function handleInputChange(event) {
    setInputValue(event.target.value);
  }

  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <TextField
          label="Cc"
          name="cc"
          value={inputValue}
          formikProps={formikProps}
          onKeyDown={handleKeyDown}
          placeholder="Type email and press space or enter."
          InputProps={{
            startAdornment: formikProps.values?.cc?.map((item, index) => (
              <Chip
                key={item}
                tabIndex={-1}
                label={item}
                onDelete={() => handleDelete(index)}
              />
            )),
            onChange: (event) => {
              handleInputChange(event);
            },
          }}
        />
      </Grid>
    </Grid>
  );
}
